<template>
  <v-card width="100vw" height="90vh" elevation="0">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <v-progress-circular
            :width="5"
            :size="100"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
        <v-col cols="12" justify="center" align="center">
          <div>Cargando datos...</div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "ViewLoading"
};
</script>
